import { GET_TRADED_ITEMS, GET_TRADED_ITEMS_ERROR, GET_TRADED_ITEMS_SUCCESS } from './TradedProducts.actions'

const tradedProductsState = {
  chartStructure: [],
  csvStructure: [],
  error: null,
  loading: false,
  type: 'segments'
}

/**
 * Traded Products's reducer.
 */
const tradedProductsReducer = (state = tradedProductsState, { payload, type }) => {
  switch (type) {
    case GET_TRADED_ITEMS: {
      // TODO: Find out why the treemap does not render correctly when changing between levels.
      // Weirdly when resetting the data the chart actually does renders right.
      return { ...state, chartStructure: [], loading: true }
    }
    case GET_TRADED_ITEMS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_TRADED_ITEMS_SUCCESS: {
      return { ...state, ...payload, loading: false }
    }
    default: {
      return state
    }
  }
}

export default tradedProductsReducer
